// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"h0pg9kZm-ygQcjIUaWoCo"};